import moment from 'moment'

export const toGanttBarChartData = data => {
  if (!data || !data.deals) return []

  return data.deals
    .filter(deal => deal.projectEndDate && deal.projectStartDate)
    .map(deal => ({
      start: moment(deal.projectStartDate).toDate(),
      end: moment(deal.projectEndDate).toDate(),
      name: deal.name,
      id: deal.id,
      type: 'task',
      isDisabled: false,
      styles: {
        backgroundColor:
          deal.name === ''
            ? '#000000'
            : '#' +
              deal.name
                .split('')
                .map((char, index) => deal.name.charCodeAt(index))
                .reduce((a, b) => (a + b) % 16777215, 0)
                .toString(16)
                .padStart(6, '0')
      }
    }))
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toCategories = categories =>
  categories.map(category => ({
    value: category.id,
    label: category.name,
    system: category.system,
    code: category.code
  }))
